import api from '@/api.js';
const state = {
    filter: { visibility: 4 },
    tags: [],
    tag_tree: {},
    items: [],
    item: {},
    total: 0,
    content: null
};
const mutations = {
    clear(state) {
        state.item = {};
        state.content = null;
        // state.filter = {};
        state.items = [];
    },
    save_tags(state, tags) {
        state.tags = tags;
    },
    saveTagTree(state, tagTree) {
        state.tag_tree = tagTree;
    },
    setTotal(state, total) {
        state.total = total;
    },
    setItems(state, items) {
        state.items = items;
    },
    addItems(state, items) {
        // state.items = [...state.items, ...items];
        state.items.push(...items);
    },
    updateFilter(state, filter) {
        state.filter = filter;
    },
    item(state, item) {
        state.item = item;
    },
    content(state, c) {
        state.content = c;
    }
};
const getters = {
    filter: state => state.filter,
    tags: state => state.tags,
    tagTree: state => state.tag_tree,
    items: (state) => state.items,
    total: (state) => state.total || 0,
    item: (state) => state.item,
    content(state) {
        return state.content;
    }
};
const actions = {
    clear({ commit }) {
        commit('clear');
    },
    tags({ commit }) {
        api.media.tags().then(res => commit('save_tags', res.data));
    },
    getTagTree({ commit }) {
        api.media.tagsHierarchy().then(res => commit('saveTagTree', res.data));
    },
    count({ commit }, filter) {
        api.media.count(filter).then(res => {
            console.log('vuex count:', filter, res.data.total);
            // commit('updateFilter', filter);
            commit('setTotal', res.data.total);
        });
    },
    page({ commit }, page) {
        commit("page", page);
    },
    updateFilter({ commit }, filter) {
        console.log('vuex update filter', filter);
        commit('updateFilter', filter);
    },
    list({ commit }, filter) {
        console.log('vuex load FILTER', filter, filter.page);
        api.media.files(filter)
            .then(res => {
            const { page, total, items } = res.data;
            // commit('updateFilter', { ...filter, page, total });
            commit("setItems", items);
            console.log('vuex loaded page', filter.page, '   ', items.map(x => x.date_taken));
        });
    },
    append({ commit }, filter) {
        console.log('vuex append FILTER', filter, filter.page);
        api.media.files(filter)
            .then(res => {
            const { page, total, items } = res.data;
            // commit('updateFilter', { ...filter, page, total });
            commit("addItems", items);
            console.log('vuex appended page', filter.page, '   ', items.map(x => x.date_taken));
        });
    },
    item({ commit }, id) {
        return api.media.item(id)
            .then(res => {
            commit("item", res.data);
        });
    },
    content({ commit }, id) {
        return api.media.content(id)
            .then(res => {
            commit("content", res.data);
            return res.data;
        });
    },
    batchUpdate({ dispatch }, payload) {
        // payload: { ids: number[], tags: number[], visibility: number }
        return api.media.batchUpdate(payload).then(() => {
            // Optional: Liste neu laden oder selektierte IDs entfernen
            dispatch('count', state.filter);
            dispatch('list', state.filter); // oder: commit('clear') o.ä.
        });
    }
};
export const Media = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
